import React from "react";

import { SpinnerContainer, Bouce1, Bouce2 } from "./styles";

export default function Spinner() {
  return (
    <SpinnerContainer>
      <Bouce1 />
      <Bouce2 />
    </SpinnerContainer>
  );
}
